import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAuthStore } from '../stores/authStore';

// Packet A4: entitlement lives in a React Query, never in persisted Zustand.
// The /users/me/access endpoint is cheap (no joins). staleTime=30s keeps
// guard decisions fresh; window focus + reconnect refetches cover the case
// where an admin action (revoke/resubscribe) happened in another tab or
// while the tab was backgrounded.
export function useAccess() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['access'],
    queryFn: () => api.get('/users/me/access'),
    enabled: isAuthenticated,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
